// extracted by mini-css-extract-plugin
module.exports = {"image":"basic-form_image__11s9x","field":"basic-form_field__sioDq","textarea":"basic-form_textarea__1-DhH"};